import { bool, func, number, shape, string } from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

export default function ProductOption(
    { option, allOptionsEmpty, variantsWithSelectedOptions,
        isLastOptionFromSelected, selectOption, defaultValue }) {
    const [optionValue, setOptionValue] = useState('');
    const onValueChange = useCallback((e) => {
        const { value } = e.target;
        setOptionValue(value);
        selectOption(option.id, value);
    }, [selectOption, option.id]);
    const isOptionValueAvailable = (optionId, value) => (
        allOptionsEmpty
        || defaultValue === value
        || variantsWithSelectedOptions(isLastOptionFromSelected(optionId))
            .some(
                (variant) => variant.Options.some(
                    (o) => (
                        o.id === optionId
                        && o.VariantSelectedOptions.optionValueSelected === value
                    )
                )
            )
    );
    useEffect(() => {
        setOptionValue(defaultValue);
    }, [defaultValue]);
    return (<Form.Group
        style={{
            flexGrow: 1,
        }}
        controlId={`Option-${option.id}`}>
        <Form.Label>{option.optionName.toUpperCase()}</Form.Label>
        <Form.Select
            value={optionValue}
            onChange={onValueChange}>
            <option
                value={''}>-- SELECT {option.optionName.toUpperCase()} --</option>
            {option.optionValue
                .split(', ')
                .map((value, index) => <option
                    key={`${option.optionName}-${index}`}
                    value={value}
                    className={'addtocart--toggle-button'}
                    disabled={!isOptionValueAvailable(option.id, value)}
                >{value}</option>)}
        </Form.Select>
    </Form.Group>);
}

ProductOption.propTypes = {
    option: shape({
        id: number,
        optionName: string,
        optionValue: string,
    }),
    allOptionsEmpty: bool,
    variantsWithSelectedOptions: func,
    isLastOptionFromSelected: func,
    selectOption: func,
    defaultValue: string,
};